import { styled } from 'styled-components';

export const DateTime = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  gap: 16px;
`;
